(function () {
  function money(c) { return '$' + (c / 100).toFixed(2); }

  function getCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }

  function setText(el, t) { if (el) el.textContent = t; }

  function updateHeaderCount(count) {
    var links = document.querySelectorAll('.fb-site-action a, .fb-mobile-panel__meta a');
    links.forEach(function (a) {
      var t = a.textContent.trim().toLowerCase();
      if (t.indexOf('bag') === 0) a.textContent = 'bag · ' + count;
    });
  }

  function renderBag(cart) {
    var count = cart.item_count;
    setText(document.getElementById('cartCount'), count);
    var mm = document.getElementById('mmCart');
    setText(mm, count + (count === 1 ? ' item' : ' items'));
    setText(document.getElementById('maniTotal'), money(cart.total_price));
    updateHeaderCount(count);
    var list = document.getElementById('maniList');
    if (!list) return;
    if (!cart.items.length) {
      list.innerHTML = '<div class="mani-empty">nothing in your bag yet. the objects are waiting.</div>';
      return;
    }
    list.innerHTML = '';
    cart.items.forEach(function (it) {
      var row = document.createElement('div');
      row.className = 'mani-item';
      var vt = (it.variant_title && it.variant_title.toLowerCase() !== 'default title') ? ('size ' + it.variant_title + ' · ') : '';
      var img = document.createElement('img');
      if (it.image) img.src = it.image;
      img.alt = '';
      var info = document.createElement('div');
      var h = document.createElement('h4'); h.textContent = (it.product_title || '').toLowerCase();
      var s = document.createElement('small'); s.textContent = vt + money(it.final_line_price);
      info.appendChild(h); info.appendChild(s);
      var rm = document.createElement('button');
      rm.className = 'rm'; rm.type = 'button'; rm.textContent = 'remove';
      rm.addEventListener('click', function () { changeCart(it.key, 0); });
      row.appendChild(img); row.appendChild(info); row.appendChild(rm);
      list.appendChild(row);
    });
  }

  function refresh() { return getCart().then(renderBag).catch(function () {}); }

  function changeCart(id, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderBag);
  }

  function toastMsg(m) { if (typeof window.toast === 'function') window.toast(m); }

  function addToCart(vid, name, btn) {
    if (btn) btn.disabled = true;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return r.json();
    }).then(function () {
      return refresh();
    }).then(function () {
      if (btn) btn.disabled = false;
      toastMsg((name || 'object') + ' — added to bag');
      document.body.classList.add('bz');
      if (typeof window.openMani === 'function') window.openMani();
    }).catch(function () {
      if (btn) btn.disabled = false;
      toastMsg('could not add — try again');
    });
  }

  function pickVariant(kind) {
    try {
      if (kind === 'bz') {
        if (typeof bzVid !== 'undefined' && bzVid) {
          var bn = (typeof bzIdx !== 'undefined' && typeof P !== 'undefined' && P[bzIdx]) ? P[bzIdx].n : '';
          return { vid: bzVid, name: bn };
        }
      } else {
        if (typeof acqVid !== 'undefined' && acqVid) {
          var an = (typeof acqIdx !== 'undefined' && typeof P !== 'undefined' && P[acqIdx]) ? P[acqIdx].n : '';
          return { vid: acqVid, name: an };
        }
      }
    } catch (e) {}
    return null;
  }

  // Capture-phase handler on document so it runs before (and cancels) the
  // section's own add-to-manifest / execute-order listeners.
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var add = t.closest('#bzAdd, #acqAdd');
    var checkout = t.closest('#checkoutBtn');
    if (add) {
      e.stopImmediatePropagation();
      e.preventDefault();
      var kind = add.id === 'bzAdd' ? 'bz' : 'acq';
      var v = pickVariant(kind);
      if (!v || !v.vid) { toastMsg('select a size first'); return; }
      addToCart(v.vid, v.name, add);
    } else if (checkout) {
      e.stopImmediatePropagation();
      e.preventDefault();
      getCart().then(function (cart) {
        if (!cart.item_count) { toastMsg('your bag is empty'); return; }
        window.location.href = '/checkout';
      });
    }
  }, true);

  function relabel() {
    setText(document.getElementById('bzAdd'), 'add to bag');
    setText(document.getElementById('acqAdd'), 'add to bag →');
    setText(document.getElementById('checkoutBtn'), 'check out →');
    var pill = document.querySelector('.fbx .pill.hot');
    if (pill && pill.firstChild && pill.firstChild.nodeType === 3) pill.firstChild.textContent = 'bag · ';
    var title = document.querySelector('.fbx .mani .acq-head b');
    if (title) title.textContent = 'your bag';
    var lbl = document.querySelector('.fbx .mm-item[data-mode="mani"] .mm-label');
    if (lbl) lbl.textContent = 'bag';
  }

  function init() {
    if (!document.querySelector('.fbx')) return false;
    // Route the section's own renderMani() calls (e.g. from openMani) to the real cart.
    try { window.renderMani = refresh; } catch (e) {}
    relabel();
    refresh();
    return true;
  }

  if (!init()) {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
